export const NEWS_STATE = {
  OFF: 0,
  ON: 1,
};

export const NEWS_STATE_OPTIONS = [
  { value: '', label: '全部' },
  { value: String(NEWS_STATE.ON), label: '已發布' },
  { value: String(NEWS_STATE.OFF), label: '已下架' },
];

export const NEWS_HOME_SHOW_OPTIONS = [
  { value: '', label: '全部' },
  { value: '1', label: '是' },
  { value: '0', label: '否' },
];

export const NEWS_SOURCE_LABELS = {
  SPIDER: '爬蟲',
  ADMIN: '後台',
};

export const NEWS_CATEGORY_OPTIONS = [
  { value: '', label: '全部' },
  { value: 'EXCHANGE', label: '交易所' },
  { value: 'TRAVEL', label: '旅遊' },
];

export const NEWS_PROVIDER_OPTIONS = [
  { value: '', label: '全部' },
  { value: 'KUCOIN', label: 'Kucoin' },
  { value: 'MANUAL', label: '後台手動' },
  { value: 'WEATHER_API', label: '天氣 API' },
  { value: 'TRAVEL_NEWS_API', label: '旅遊資訊 API' },
];

export const NEWS_CATEGORY_LABELS = {
  EXCHANGE: '交易所',
  TRAVEL: '旅遊',
};

export const NEWS_PROVIDER_LABELS = {
  KUCOIN: 'Kucoin',
  MANUAL: '後台手動',
  WEATHER_API: '天氣 API',
  TRAVEL_NEWS_API: '旅遊資訊 API',
};

export const EN_LANG_CODE = 'en_US';

export function formatNewsState(value) {
  if (value === NEWS_STATE.ON) {
    return '已發布';
  }
  if (value === NEWS_STATE.OFF) {
    return '已下架';
  }
  return '—';
}

export function formatHomeShow(value) {
  if (value === 1) {
    return '是';
  }
  if (value === 0) {
    return '否';
  }
  return '—';
}

export function formatNewsSource(value) {
  return NEWS_SOURCE_LABELS[value] || value || '—';
}

export function formatNewsCategory(value) {
  return NEWS_CATEGORY_LABELS[value] || value || '—';
}

export function formatNewsProvider(value) {
  return NEWS_PROVIDER_LABELS[value] || value || '—';
}

export function toDateTimeInput(value) {
  if (!value) {
    return '';
  }
  const text = String(value);
  if (text.length >= 16) {
    return `${text.slice(0, 10)}T${text.slice(11, 16)}`;
  }
  return text;
}

export function fromDateTimeInput(value) {
  if (!value) {
    return '';
  }
  if (value.includes('T')) {
    const [date, time] = value.split('T');
    const hhmm = time.length === 5 ? `${time}:00` : time;
    return `${date} ${hhmm}`;
  }
  return value;
}

export function buildNewsPageParams(pageNo, pageSize, filters) {
  const params = { pageNo, pageSize };
  if (filters.dataState !== '') {
    params.dataState = Number(filters.dataState);
  }
  if (filters.viewState !== '') {
    params.viewState = Number(filters.viewState);
  }
  if (filters.title?.trim()) {
    params.title = filters.title.trim();
  }
  if (filters.category) {
    params.category = filters.category;
  }
  if (filters.provider) {
    params.provider = filters.provider;
  }
  const start = fromDateTimeInput(filters.startTimeInput);
  const end = fromDateTimeInput(filters.endTimeInput);
  if (start) {
    params.startTime = start;
  }
  if (end) {
    params.endTime = end;
  }
  return params;
}

export function emptyDetail(lang) {
  return {
    lang,
    title: '',
    body: '',
    image: '',
    crawlerKey: '',
    crawlerTime: null,
    translateModule: 'DEFAULT',
  };
}

export function mergeDetailsWithLanguages(languages, existingDetails = []) {
  const langEntries = [];
  const seen = new Set();

  (languages || []).forEach((lang) => {
    const code = lang.code || lang;
    if (!code || seen.has(code)) {
      return;
    }
    seen.add(code);
    langEntries.push({
      code,
      label: lang.label || code,
    });
  });

  (existingDetails || []).forEach((item) => {
    if (!item?.lang || seen.has(item.lang)) {
      return;
    }
    seen.add(item.lang);
    const langEnumLabel = item.lang;
    langEntries.push({
      code: item.lang,
      label: langEnumLabel,
    });
  });

  const map = new Map((existingDetails || []).map((item) => [item.lang, { ...item }]));
  return langEntries.map(({ code, label }) => {
    const found = map.get(code);
    return found ? { ...found, lang: code, _label: label } : { ...emptyDetail(code), _label: label };
  });
}

export function stripDetailMeta(details) {
  return (details || []).map(({ _label, ...rest }) => ({
    ...rest,
    image: rest.image || '',
  }));
}
